<main
  style="
    background: linear-gradient(
        180deg,
        rgba(255, 247, 237, 0.2) 0%,
        #fff7ed 100%
      ),
      #fff;
  "
>
  <section
    class="flex flex-col min-h-screen px-4 lg:container xl:px-20 lg:mx-auto md:pt-6 md:pb-20"
  >
    <router-outlet></router-outlet>
  </section>
</main>
